<template>
    <div class="cell-square-dropdown-item">
        <IconButton
            v-b-tooltip.hover
            icon="Delete"
            title="Delete"
            variant="light"
            size="xs"
            class="text-danger d-flex justify-content-center align-items-center"
            @click.native="$emit('delete')"
        />
        <IconButton
            v-b-tooltip.hover
            icon="Duplicate"
            title="Duplicate"
            variant="light"
            size="xs"
            class="d-flex justify-content-center align-items-center"
            @click.native="$emit('duplicate')"
        />
        <IconButton
            v-b-tooltip.hover
            icon="ListNested"
            title="Clear All"
            variant="danger"
            size="xs"
            class="btn-focus-none d-flex justify-content-center align-items-center"
            @click.native="$emit('delete-text')"
        />
    </div>
</template>

<script>
import IconButton from '../../stories/components/buttons/IconButton.vue'

export default {
    components: {
        IconButton,
    },
}
</script>
